import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UploadDocumentComponent } from '../../../components/upload-document/upload-document.component';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
@Component({
  selector: 'app-vcns-approval',
  standalone: false,
  templateUrl: './vcns-approval.component.html',
  styleUrl: './vcns-approval.component.scss',
})
export class VcnsApprovalComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadDocumentComponent) uploadDocumentComp!: UploadDocumentComponent;
  @Input() id: any;
  @Input() getUrl: any;
  @Input() postUrl: any;
  @Output() stepCompleted = new EventEmitter<void>();
  vcnsApprovalForm: FormGroup;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  baseUrl: string = environment.APIUrl;
  payload: ProposalPayload;
  @Input() step: any;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() isEditable: boolean = false;
  isEditorDisabled: boolean = false;
  userID: any;
  commentForm: FormGroup;
  allDmsFiles: any[] = [];
  vcnsApprovalId: any;
  vcnsApprovalData: any;
  remark: any = '';
  // upload doc progress
  uploadProgress: number = 0;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    this.vcnsApprovalForm = this.fb.group({
      // No form fields needed for document-only upload
    });
    this.commentForm = this.fb.group({
      // Initialize comment form
    });
    this.needGenForm = this.fb.group({
      nomenclature: [''],
      platform: [''],
      tenderMode: [''],
      equipment: [''],
      system: [''],
      qtyReqd: [''],
      qtyPrototype: [''],
      qtyBulk: [''],
      estimatedDevelopmentCost: [''],
      estimatedUnitCost: [''],
      llp: [''],
      lpyear: [null],
      poev: [''],
      consignee: [''],
      technologyInsertion: [''],
      dualUseTechnology: [null],
      approval_apso: [''],
      justificationText: [''],
      exportPotential: [''],
      // Make scheme fields
      brief_description: [''],
      requirement_met: [''],
      exchequer: [''],
      indigenously_designed: [''],
      capability_infrastructure: [''],
      ltpp: [''],
      lead_development: [''],
      indigenise_equipment: [''],
      rfi_indigenous: [''],
      collaboration_envisaged: [''],
      drdo_psu: [''],
      technical_specifications: [''],
      operationalRequirements: [''],
      drawings_manuals: [''],
      sample_indigenisation: [''],
      annual_Acquisition: [''],
      trials_environments: [''],
      photograph_item: [''],
      export_potential: [''],
      project_similar: [''],
      nodal_officer_details: [''],
      critical_technology: [''],
      drdo_infrastructure: [''],
      trial_infrastructure: [''],
      // Rev-specific
      technical_details: [''],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    console.log('vcns-approval component', this.step, this.schemeType, this.stepDetails);
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
    this.getVcnsApprovalData();
    this.getNeedGenerationData();
  }



  ngAfterViewInit() {
    this.previousInit = {
      ...this.init,
      readonly: true
    };
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }

  editorReady = false;
  init: EditorComponent['init'] = init;
  previousInit: EditorComponent['init'] = init;
  needGenForm: FormGroup;
  needGenData: any;
  needGenDmsFiles: any[] = [];
  needGenProposalStep: any;
  
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }

  goToNextStep() {
    this.stepCompleted.emit();
  }

  getVcnsApprovalData() {
    const url = `/make1/vcns/approval/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
    
    this.api.getAPI(url).subscribe((res: any) => {
      console.log('vcns-approval data', res);
      
      let responseData = null;
      
      if (Array.isArray(res) && res.length > 0) {
        responseData = res[0];
      } else if (res && res.vcns_approval) {
        responseData = res.vcns_approval;
      } else if (res && typeof res === 'object' && !Array.isArray(res) && res.id) {
        responseData = res;
      }
      
      this.vcnsApprovalData = responseData;
      
      // Handle DMS files
      this.allDmsFiles = this.vcnsApprovalData?.dms_files || [];
      
      // Load remarks if exists (also populate from justification if available)
      if (responseData) {
        this.remark = responseData.comment || responseData.remark || responseData.justification || '';
        this.vcnsApprovalId = responseData.id;
      }
    });
  }

  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    this.api.postAPI('/make1/vcns/approval/', formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res vcns-approval upload data', res);
        this.getVcnsApprovalData(); // Refresh data after upload
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document uploaded successfully',
        });
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document upload failed',
        });
      }
    });
  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('type_doc', updatedDoc.type_document);
    formData.append('description', updatedDoc.description);

    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    this.api.putAPI(`/make1/vcns/approval/${updatedDoc.id}/`, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
        this.getVcnsApprovalData(); // Refresh data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document updated successfully',
        });
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document update failed',
        });
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.api.deleteAPI(`/make1/vcns/approval/${docId}/`).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
        this.getVcnsApprovalData(); // Refresh data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Document deleted successfully',
        });
      },
      error: (err) => {
        console.error('❌ Delete failed:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Document deletion failed',
        });
      }
    });
  }

  onSubmit() {
    // if (!this.remark || this.remark.trim() === '') {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Warning',
    //     detail: 'Please enter remarks before saving',
    //   });
    //   return;
    // }

    const payload = {
      comment: this.remark,
      justification: this.remark,
      proposal_step: this.id,
    };

    if (this.vcnsApprovalId) {
      this.api.putAPI(`/make1/vcns/approval/${this.vcnsApprovalId}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Remarks saved successfully',
          });
          this.getVcnsApprovalData();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error updating remarks:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save remarks',
          });
        }
      });
    } else {
      this.api.postAPI('/make1/vcns/approval/', payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Remarks saved successfully',
          });
          this.getVcnsApprovalData();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error saving remarks:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save remarks',
          });
        }
      });
    }
  }

  generatePDF() {
    const data: any[] = [
      { key: 'Proposal Name', value: this.payload.proposal_name },
      { key: 'Remarks', value: this.remark || '' },
    ];

    const payload = {
      url: '/revenue/need/version-control/',
      data,
    };

    this.generatePDFEmitter.emit(payload);
  }

  expandedSections: { [key: string]: boolean } = {
    uploads: true,
    mainExpansion: false,
    basicInfo: false,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    needGenUploads: false,
    information: false,
    justification: false,
    makeDetailedFields: false,
    requirementIndigenise: false,
    manufacture: false,
    draftProjectReport: false,
  };

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }

  getNeedGenerationData() {
    let url = '';
    if (this.schemeType === 'tdf') {
      url = `/tdf/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
    } else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
      url = `/make1/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
    } else {
      url = `/revenue/need-generation/?proposal_step__proposal=${this.payload.proposal_id}`;
    }

    this.api.getAPI(url).subscribe((res: any) => {
      console.log('need-generation data for vcns-approval', res);
      
      let responseData = null;
      
      if (Array.isArray(res) && res.length > 0) {
        responseData = res[0];
      } else if (res && res.need_generation) {
        responseData = res.need_generation;
      } else if (res && typeof res === 'object' && !Array.isArray(res) && res.id) {
        responseData = res;
      }
      
      this.needGenData = responseData;
      
      // Handle DMS files from need generation
      if (responseData) {
        this.needGenDmsFiles = responseData.dms_files || [];
        this.needGenProposalStep = responseData.proposal_step || null;
        this.patchNeedGenFormValues(responseData);
      }
    });
  }

  patchNeedGenFormValues(data: any) {
    if (!data) return;
    
    const lppYearFromAPI = data.lpp_year;
    let lppYearDate: Date | null = null;

    if (lppYearFromAPI) {
      const yearMatch = lppYearFromAPI.toString().match(/\d{4}/);
      if (yearMatch) {
        const year = Number(yearMatch[0]);
        lppYearDate = new Date(year, 0, 1);
      }
    }

    this.needGenForm.patchValue({
      nomenclature: data?.nomenclature || '',
      platform: data?.platform || '',
      tenderMode: data?.mode_tendor || '',
      qtyReqd: data?.qty_req || data?.total_qty_req || '',
      qtyPrototype: data?.prototype_qty || '',
      qtyBulk: data?.bulk_qty || '',
      estimatedDevelopmentCost: data?.development_cost || data?.development_prototype || '',
      estimatedUnitCost: data?.unit_cost || '',
      justificationText: data?.justification || '',
      exportPotential: data?.proposed_item || data?.export_potential || '',
      equipment: data?.equipment?.name || data?.equipment || '',
      system: data?.system?.name || data?.system || '',
      consignee: data?.consignee || '',
      technologyInsertion: data?.brief_description || '',
      approval_apso: data?.approval_apso || '',
      llp: data?.lpp_cost || '',
      lpyear: lppYearDate,
      poev: data?.poev || '',
      dualUseTechnology: data?.dual_technology === true || data?.dual_technology === 'true',
      // Make scheme fields
      brief_description: data?.brief_description || '',
      requirement_met: data?.requirement_met || '',
      exchequer: data?.exchequer || '',
      indigenously_designed: data?.indigenously_designed || '',
      capability_infrastructure: data?.capability_infrastructure || '',
      ltpp: data?.ltpp || '',
      lead_development: data?.lead_development || '',
      indigenise_equipment: data?.indigenise_equipment || '',
      rfi_indigenous: data?.rfi_indigenous || '',
      collaboration_envisaged: data?.collaboration_envisaged || '',
      drdo_psu: data?.drdo_psu || '',
      technical_specifications: data?.technical_specifications || '',
      operationalRequirements: data?.operational_requirement || '',
      drawings_manuals: data?.drawings_manuals || '',
      sample_indigenisation: data?.sample_indigenisation || '',
      annual_Acquisition: data?.annual_Acquisition || '',
      trials_environments: data?.trials_environments || '',
      photograph_item: data?.photograph_item || '',
      export_potential: data?.export_potential || '',
      project_similar: data?.project_similar || '',
      nodal_officer_details: data?.nodal_officer_details || '',
      critical_technology: data?.critical_technology || '',
      drdo_infrastructure: data?.drdo_infrastructure || '',
      trial_infrastructure: data?.trial_infrastructure || '',
      // Rev-specific
      technical_details: data?.technical_details || '',
    });
    
    this.needGenForm.disable();
  }

  get isMakeScheme(): boolean {
  return this.schemeType === 'makeI' || 
         this.schemeType === 'makeII' || 
         this.schemeType === 'makeIII';
}


}

interface ProposalPayload {
  proposal_id: number;
  proposal_name: string;
}

